export const stripVersionFromImplementationName = (name: string): string =>
  name.replace(
    /\s+\((Legacy|Deprecated|(?:[0-9]+\.[0-9]+\.[0-9]+(-[a-z0-9]+)?))\)$/i,
    "",
  );
